module.exports = __webpack_public_path__ + "img/operational.8d00d736.png";